(function () {

    a3_cabin_reports.directive('media', media);

       /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name ground Media
   * @restrict E
   * @description
   *   Initialize panel with media of training selection, aircraft types & synthetic devices
   * @example
   *   Usage:
   *   <media></media>
   * @ngInject
   */

    function media($location, CourseFactory) {
        function link($scope, attrs) {

            $scope.addAircraftRow = addAircraftRow;
            $scope.removeAircraftRow = removeAircraftRow;

            $scope.showDowntimeDuration = showDowntimeDuration;
            $scope.clearDowntimeDuration = clearDowntimeDuration;
            
            $scope.isObjectEmpty = isObjectEmpty;
    
            $scope.downtimeDuration = {
                radioValue: 'false',
                show: false,
                minutes: null
            }
            $scope.sessionDuration = $scope.groundDuty ? (new Date($scope.groundDuty.DutyEnd) - new Date($scope.groundDuty.DutyBegin)) / (1000*60) : undefined;
            $scope.downtimeDurationValueChanged = downtimeDurationValueChanged;
         
            initializeMedia();

            $scope.filterSyntheticDevices = filterSyntheticDevices;
        
            function isObjectEmpty(obj){
                return Object.keys(obj).length === 0;
            }

            function initializeMedia() {
                if ($scope.course) {
                    if (!$scope.course.Media) {
                        // Create Media object
                        $scope.course.Media = {
                            inputAircrafts: [],
                            selectedAircraft: {
                                selection: undefined
                            },
                            selectedDevice: {
                                selection: undefined
                            },
                            radioModel: "",
                        };
                    }

                    if ($scope.course.Media.radioModel == "" || mediaRemoved()) {
                        //Auto select media on init or if selection was removed in admin settings
                        if ($scope.selectedPhase.InSimulator) $scope.course.Media.radioModel = "Simulator";
                        if ($scope.selectedPhase.InAircraft) $scope.course.Media.radioModel = "Aircraft";
                        if ($scope.selectedPhase.InClassroom) $scope.course.Media.radioModel = "Classroom";
                    }

                    if ($scope.selectedPhase.InSimulator) {
                        // Check if training centers exist
                        if ($scope.course.TrainingCenters && $scope.course.TrainingCenters.length > 0) {
                            var defaultCenter = $scope.course.TrainingCenters.find(x => x.IsDefault);

                            if (defaultCenter) {
                                $scope.course.selectedTrainingCenter = defaultCenter.Id;
                                filterSyntheticDevices(defaultCenter.Id);
                            } else {
                                // If no default center, select "No Center"
                                $scope.course.selectedTrainingCenter = 'No Center';
                                // No need to filter devices based on training center, show all devices
                                filterSyntheticDevices('No Center');
                            }
                        }

                        // Auto-select the first device if not already selected and devices exist
                        if ($scope.course.SyntheticDevices && !isObjectEmpty($scope.course.SyntheticDevices)) {
                            if (!$scope.course.Media.selectedDevice) {
                                $scope.course.Media.selectedDevice = {};
                            }

                            if (!$scope.course.Media.selectedDevice.selection) {
                                // Select the first available device
                                $scope.course.Media.selectedDevice.selection = Object.keys($scope.course.SyntheticDevices)[0];
                            }
                        } else {
                            // No devices available, clear the selection
                            $scope.course.Media.selectedDevice.selection = undefined;
                        }
                    }

                    // Create downtime duration object
                    $scope.downtimeDuration = {
                        radioValue: 'false',
                        show: false,
                        minutes: null
                    }
                }
            }

            function filterSyntheticDevices(trainingCenterId) {
                if (!$scope.course.AllSyntheticDevices) {
                    return;
                }

                if (trainingCenterId && trainingCenterId !== 'No Center') {
                    $scope.course.SyntheticDevices = $scope.course.AllSyntheticDevices.filter(function (device) {
                        return device.TrainingCenterId == trainingCenterId;
                    });

                    if ($scope.course.SyntheticDevices && $scope.course.SyntheticDevices.length > 0) {
                        var defaultDevice = $scope.course.SyntheticDevices.find(function (device) {
                            return device.IsDefault;
                        });
                        if (defaultDevice) {
                            $scope.course.Media.selectedDevice.selection = defaultDevice.Id;
                        } else {
                            $scope.course.Media.selectedDevice.selection = null;
                        }
                    } else {
                        $scope.course.Media.selectedDevice.selection = $scope.course.AllSyntheticDevices;
                    }

                } else {
                    $scope.course.SyntheticDevices = $scope.course.AllSyntheticDevices;
                }
            }
            
            function mediaRemoved(){
                return  ($scope.course.Media.radioModel == "Simulator" && !$scope.selectedPhase.InSimulator) ||
                        ($scope.course.Media.radioModel == "Aircraft" && !$scope.selectedPhase.InAircraft) ||
                        ($scope.course.Media.radioModel == "Classroom" && !$scope.selectedPhase.InClassroom);
            }

            function addAircraftRow(){
                var aircraftTypes = $scope.course.AircraftTypes;
                if($scope.course.Media.selectedAircraft.selection != undefined && aircraftTypes && aircraftTypes.includes($scope.course.Media.selectedAircraft.selection) && (!$scope.course.Media.inputAircrafts || !$scope.course.Media.inputAircrafts.includes($scope.course.Media.selectedAircraft.selection))){
                    //Add to selected
                    if(!$scope.course.Media.inputAircrafts){
                        $scope.course.Media.inputAircrafts = [];
                    }
                    $scope.course.Media.inputAircrafts.push($scope.course.Media.selectedAircraft.selection);
                    
                    //Remove from options
                    $scope.course.AircraftTypes = aircraftTypes.filter(function(aircraft){
                        return aircraft != $scope.course.Media.selectedAircraft.selection;
                    });
                    
                    //Clear 
                    $scope.course.Media.selectedAircraft.selection = undefined;

                }
            }
        
            function removeAircraftRow(aircraft){
                //Remove from selected
                var acIndex = $scope.course.Media.inputAircrafts.indexOf(aircraft);
                $scope.course.Media.inputAircrafts.splice(acIndex, 1);
        
                //Add back to options
                $scope.course.AircraftTypes.push(aircraft);
            }

            function showDowntimeDuration(showDowntime) {
                if(showDowntime == true) {
                   $scope.downtimeDuration.show = true;
                } else{
                   $scope.downtimeDuration.show = false;
                }
            }

            function clearDowntimeDuration() {
                $scope.downtimeDuration.minutes = null;
            };

            function downtimeDurationValueChanged(){      
                if ($scope.downtimeDuration.minutes > $scope.sessionDuration) {
                    $scope.downtimeDuration.minutes = $scope.sessionDuration;
                } 
                return $scope.downtimeDuration.minutes;
 
            }

        }

        return {
            restrict: 'E',
            templateUrl: "views/Training/media.tpl.html",
            $scope : false,
            terminal: true,
            link: link
        }
    }
})();